module.exports = __webpack_public_path__ + "static/grbmember1-d8df32f26d9c24326ede59b08f6ae059.svg";